<template>
  <div>
    <vs-tabs>
      <vs-tab label="Posters">
        <div class="con-tab-ejemplo">
          <vs-row v-if="images && images.posters">
            <vs-col
              v-for="(poster, index) in images.posters"
              :key="index"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
              class="p-3"
            >
              <img
                :src="`https://image.tmdb.org/t/p/w500/${poster.file_path}`"
                width="150"
                @click="selectConfirm(poster, 'poster')"
              />
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>
      <vs-tab label="banners">
        <div class="con-tab-ejemplo">
          <vs-row v-if="images && images.posters">
            <vs-col
              v-for="(poster, index) in images.posters"
              :key="index"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
              class="p-3"
            >
              <img
                :src="`https://image.tmdb.org/t/p/w500/${poster.file_path}`"
                width="150"
                @click="selectConfirm(poster, 'banner')"
              />
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>
      <vs-tab label="Logos">
        <div class="con-tab-ejemplo">
          <vs-row v-if="images && images.logos">
            <vs-col
              v-for="(logo, index) in images.logos"
              :key="index"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
              class="p-3"
            >
              <img
                :src="`https://image.tmdb.org/t/p/w500/${logo.file_path}`"
                width="150"
                @click="selectConfirm(logo, 'logo')"
              />
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>
      <vs-tab label="Backdrops">
        <div class="con-tab-ejemplo">
          <vs-row v-if="images && images.backdrops">
            <vs-col
              v-for="(backdrop, index) in images.backdrops"
              :key="index"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              class="p-3"
            >
              <img
                :src="`https://image.tmdb.org/t/p/w500/${backdrop.file_path}`"
                @click="selectConfirm(backdrop, 'backdrop')"
              />
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
export default {
  props: ["movie"],
  data() {
    return {
      images: [],
      selected: [],
      type:'',
    };
  },
  created() {
    if (this.movie && this.movie.response.kind == "1") {
      this.fetchData();
    } else {
      this.getSeriesId();
    }
  },
  methods: {
    fetchData(id = 0) {
      var link = `https://api.themoviedb.org/3/movie/${this.movie.response.imdb}?api_key=501537b469791e11f39d1a3d2e45da12&append_to_response=credits,images&language=en`;
      if (id != 0) {
        link = `https://api.themoviedb.org/3/tv/${id}?api_key=501537b469791e11f39d1a3d2e45da12&append_to_response=credits,images&language=en`;
      }
      fetch(link)
        .then((res) => res.json())
        .then((res) => {
          this.images = res.images;
        });
    },
    getSeriesId() {
      fetch(
        `https://api.themoviedb.org/3/find/${this.movie.response.imdb}?api_key=501537b469791e11f39d1a3d2e45da12&language=en-US&external_source=imdb_id`
      )
        .then((res) => res.json())
        .then((res) => {
          this.fetchData(res.tv_results[0].id);
        });
    },
    selectConfirm(data, type) {
      this.selected = data;
      this.type=type;
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `change ${type}`,
        text: `Are you sure to apply  (${type})?`,
        accept: this.apply,
        close: this.close,
      });
    },
    apply() {
        this.$vs.loading()
    const data=new FormData();
    data.append('movie',this.movie.response.id);
    data.append('type',this.type);
    data.append('path',`https://image.tmdb.org/t/p/original/${this.selected.file_path}`);
    data.append('filename',this.selected.file_path);
      this.axios
        .post(`${this.$apiUrl}/movies/poster_import`,data)
        .then((res) => {
             this.$vs.loading.close()
            this.$emit('updateData');
        });
     
    },
    close() {
      this.selected = [];
    },
  },
};
</script>